import { useDispatch, useSelector } from 'react-redux'
import { useEffect } from 'react'
import { get } from 'lodash'
import { ModalBody, ModalHeader, Button } from 'reactstrap'
import NumberInput from 'react-number-format'

import { optionsSendLinkMethod } from './constants'
import RadioButton from '../../../common-components/radio-button-group'
import { getInsured } from 'e-submission/domain/data-model/form/selectors'
import { setSendLinkTextInput, setSendLinkMethod, sendLinkQuickpay } from '../../apps/actions'
import createTextInput from '../../components/Form/Input/TextInput'
import { Modal } from '../../../common-components'
import { renderErrorMessage } from 'common-components/view-logic'
import { validateSendLinkInputPopup } from '../../domain/data-model/form/validation'

const TextInput = createTextInput(({ value, onChange }) => {
  return {
    value,
    onChange,
  }
})
const SendLinkButton = (props) => {
  const { onExit, isInvalid, handlerQuickpayment } = props
  return (
    <div style={{ textAlign: 'center' }}>
      <Button
        color={isInvalid ? 'disabled' : 'primary'}
        className="primary"
        onClick={() => {
          handlerQuickpayment()
          onExit()
        }}
      >
        ยืนยัน
      </Button>
    </div>
  )
}
export const _SendLinkSmsEmailModal = (props) => {
  const { currentApp, isOpen, onExit, openModal } = props
  const method = useSelector((state) => get(currentApp, ['quickpayLink', 'sendLink', 'method'], 'sms'))
  const dispatch = useDispatch()
  const insuredInfo = getInsured(currentApp)
  const insuredEmail = get(insuredInfo, 'email', '')
  const insuredMobileNo = get(insuredInfo, 'mobileNumber', '')

  const textInput = useSelector((state) => get(currentApp, ['quickpayLink', 'sendLink', 'textInput'], insuredMobileNo))
  const validateInput = validateSendLinkInputPopup({ textInput }, method)
  const isInvalid = validateInput && !validateInput.isOk
  const options = optionsSendLinkMethod

  const setTextInput = (e) => {
    dispatch(setSendLinkTextInput('quickpayLink.sendLink.textInput', e))
  }

  const setMethod = (e) => {
    dispatch(setSendLinkMethod('quickpayLink.sendLink.method', e))
  }

  const handlerQuickpayment = () => {
    dispatch(sendLinkQuickpay())
  }

  useEffect(() => {
    setTextInput(insuredMobileNo)
  }, [insuredMobileNo])

  useEffect(() => {
    if (method !== 'sms') {
      setTextInput(insuredEmail)
    } else {
      setTextInput(insuredMobileNo)
    }
  }, [method, insuredMobileNo, insuredEmail])

  useEffect(() => {
    if (!isOpen) {
      setMethod('sms')
    }
  }, [isOpen])

  return (
    <Modal
      isOpen={isOpen}
      size="md"
      modalClassName="default-bootstrap remote-selling-modal"
      toggle={() => {
        onExit()
      }}
    >
      <ModalHeader
        toggle={() => {
          onExit()
        }}
      >
        ยืนยันการชำระผ่านลิงก์
      </ModalHeader>
      <ModalBody>
        ท่านต้องการส่งลิงก์ชำระเบี้ยประกันที่
        <div className={`form-group ${isInvalid ? 'has-danger' : ''}`}>
          <RadioButton options={options} value={method} onChange={(e) => setMethod(e)} />
          {method === 'email' ? (
            <TextInput value={textInput} setValue={setTextInput} />
          ) : (
            <NumberInput
              value={textInput}
              format={'##########'}
              onChange={(e) => setTextInput(e.target.value)}
              className="form-control"
            />
          )}
          {!isInvalid ? null : renderErrorMessage('validate-method-error-message')(validateInput, 'VALIDATION')}
          <div
            style={{ minWidth: '100%' }}
            className="validation-message attached-icon info-message-wrap form-control-feedback"
          >
            <p>ท่านสามารถเลือกช่องทางในการส่งลิงก์ผ่านทางช่องทางที่ท่านต้องการ</p>
          </div>
        </div>
        <SendLinkButton
          onExit={() => onExit()}
          openModal={() => openModal()}
          isInvalid={isInvalid}
          handlerQuickpayment={() => handlerQuickpayment()}
        />
      </ModalBody>
    </Modal>
  )
}

const SendLinkSmsEmail = _SendLinkSmsEmailModal
export default SendLinkSmsEmail
